"use client";

import { getBaseApiClient } from "@newxsystems/api-base/client";
import { getLatestBlogPostsQueryKey } from "@newxsystems/api-base/keys";
import { useQuery } from "@tanstack/react-query";
import { TootBlogPostsGrid } from "../../../../modules/content/components/TootBlogPostsGrid/TootBlogPostsGrid";
import type { ILatestBlogPostsBlockProps } from "./LatestBlogPostsBlock.props";

export const LatestBlogPostsBlockClient = (props: ILatestBlogPostsBlockProps) => {
  const { data } = useQuery({
    queryKey: getLatestBlogPostsQueryKey(props.limit),
    queryFn: async () => {
      const client = getBaseApiClient();
      return client ? client.blog.latest({ limit: props.limit }) : { items: [] };
    },
  });

  return (
    <TootBlogPostsGrid
      anchorId={props.anchorId}
      emptyText={props.emptyText}
      eyebrow={props.eyebrow}
      heading={props.heading}
      parentClass={props.parentClass}
      posts={(data?.items ?? []).slice(0, props.limit)}
      spacing={props.spacing}
      subheading={props.subheading}
    />
  );
};

LatestBlogPostsBlockClient.displayName = "Block::LatestBlogPostsBlockClient";
